<template>
    <v-container fluid class="pt-0">
        <v-row>

            <v-col cols="12" class="pa-0">
                <v-sheet class="" color="#008dd4" height="5vh"></v-sheet>
            </v-col>

            <v-col cols="12" lg="12" style="position:relative; top: -60px">
                <v-row>
                    <v-col cols="12" lg="3">
                        <v-card class="mt-3">
                            <v-list two-line subheader>
                                <v-list-item>
                                    <v-list-item-avatar>
                                        <v-icon color="#008dd4" x-large>mdi-bookshelf</v-icon>
                                    </v-list-item-avatar>

                                    <v-list-item-content>
                                        <v-list-item-title><strong>Registro total de Cursos</strong></v-list-item-title>
                                        <v-list-item-subtitle class="text-h4">{{ items.length }}</v-list-item-subtitle>
                                    </v-list-item-content>

                                </v-list-item>
                            </v-list>
                        </v-card>
                    </v-col>
                    <v-col cols="12" lg="3">
                        <v-card class="mt-3">
                            <v-list two-line subheader>
                                <v-list-item>
                                    <v-list-item-avatar>
                                        <v-icon color="#008dd4" x-large>mdi-account-group</v-icon>
                                    </v-list-item-avatar>

                                    <v-list-item-content>
                                        <v-list-item-title><strong>Total Alumnos validados</strong></v-list-item-title>
                                        <v-list-item-subtitle class="text-h4">{{ total_verified }}</v-list-item-subtitle>
                                    </v-list-item-content>

                                </v-list-item>
                            </v-list>
                        </v-card>
                    </v-col>
                </v-row>

                <v-btn color="success" class="mt-3" block dark @click="daily_cleaning_dialog = true">Limpieza de cursos</v-btn>
            </v-col>

            <v-col cols="12" lg="12" style="position:relative; top: -60px">

                <v-tabs v-model="tabs" @change="getData()">
                    <v-tab>En línea</v-tab>
                    <v-tab>Presencial</v-tab>
                </v-tabs>


                <v-card>

                    <v-container class="py-0">
                        <v-row justify="center" align="center">
                            <v-col cols="12" lg="6">

                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn fab color="#008dd4" v-bind="attrs" v-on="on" @click="create_dialog = !create_dialog" dark>
                                            <v-icon>mdi-plus-circle</v-icon>
                                        </v-btn>
                                    </template>
                                    <span>Nuevo registro</span>
                                </v-tooltip>

                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn fab color="#008dd4" v-bind="attrs" v-on="on" dark @click="languages_dialog = !languages_dialog">
                                            <v-icon>mdi-web</v-icon>
                                        </v-btn>
                                    </template>
                                    <span>Idiomas</span>
                                </v-tooltip>

                            </v-col>
                            <v-col cols="12" lg="6">
                                <v-text-field
                                    v-model="search"
                                    clearable
                                    dense
                                    outlined
                                    hide-details
                                    label="Buscar"
                                    append-icon="mdi-magnify"
                                    color="#818181"
                                ></v-text-field>
                            </v-col>
                        </v-row>
                    </v-container>

                    <v-tabs-items v-model="tabs">
                        <v-tab-item>
                            <v-data-table
                                :headers="headers"
                                :items="items"
                                :loading="loading"
                                :footer-props="footer_props"
                                :loading-text="loading_text"
                                :no-data-text="no_data_text"
                                :no-results-text="no_result_text"
                                :search="search"
                                :single-expand="true"
                                show-expand
                                multi-sort
                            >

                                <template v-slot:item.status="{ item }">
                                    <v-chip color="success" v-if="item.status">Habilitado</v-chip>
                                    <v-chip color="error" v-else>Deshabilitado</v-chip>
                                </template>

                                <template v-slot:item.user.names="{ item }">
                                    <span v-if="item.user !== null" v-text="item.user.names"></span>
                                    <span v-else>PENDIENTE</span>
                                </template>

                                <template v-slot:item.actions="{ item }">
                                    <v-menu offset-y>
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-btn icon v-bind="attrs" v-on="on">
                                                <v-icon>mdi-menu</v-icon>
                                            </v-btn>
                                        </template>
                                        <v-list dense>
                                            <v-list-item class="px-0">
                                                <v-list-item-content>
                                                    <v-btn small text @click="sampleClassDialog(item)">Clase muestra</v-btn>
                                                </v-list-item-content>
                                            </v-list-item>
                                            <v-list-item class="px-0">
                                                <v-list-item-content>
                                                    <v-btn small text @click="assignTeacherDialog(item)">Asignar docente</v-btn>
                                                </v-list-item-content>
                                            </v-list-item>
                                            <v-list-item class="px-0">
                                                <v-list-item-content>
                                                    <v-btn small text @click="() => { course = item; links_dialog = true }">Enlaces</v-btn>
                                                </v-list-item-content>
                                            </v-list-item>
                                            <v-list-item class="px-0">
                                                <v-list-item-content>
                                                    <v-btn small text @click="() => {  course = item; students_dialog = true }">Alumnos</v-btn>
                                                </v-list-item-content>
                                            </v-list-item>
                                            <v-list-item class="px-0">
                                                <v-list-item-content>
                                                    <v-btn small text @click="() => {  course = item; recordings_dialog = true }">Grabaciones</v-btn>
                                                </v-list-item-content>
                                            </v-list-item>
                                            <v-list-item class="px-0">
                                                <v-list-item-content>
                                                    <v-btn small text @click="postponement(item)">Aplazar</v-btn>
                                                </v-list-item-content>
                                            </v-list-item>
                                            <v-list-item class="px-0">
                                                <v-list-item-content>
                                                    <v-btn small text @click="finish_course(item)">Finalizar</v-btn>
                                                </v-list-item-content>
                                            </v-list-item>
                                            <v-list-item class="px-0">
                                                <v-list-item-content>
                                                    <v-btn small text @click="() => { remove_item = item; remove_dialog = !remove_dialog }">Eliminar</v-btn>
                                                </v-list-item-content>
                                            </v-list-item>
                                        </v-list>
                                    </v-menu>
                                </template>

                                <template  v-slot:expanded-item="{ headers, item }">
                                    <td :colspan="headers.length" class="px-0">
                                        <v-simple-table>
                                            <template v-slot:default>
                                                <thead>
                                                    <tr>
                                                        <th class="text-center">Día</th>
                                                        <th class="text-center">Hora de inicio</th>
                                                        <th class="text-center">Hora de termino</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr class="text-center" v-for="(schedule, index) in item.schedule" :key="index">
                                                        <td>{{ schedule.day }}</td>
                                                        <td>{{ schedule.start_time }}</td>
                                                        <td>{{ schedule.end_time }}</td>
                                                    </tr>
                                                </tbody>
                                            </template>
                                        </v-simple-table>
                                    </td>
                                </template>
                            </v-data-table>
                        </v-tab-item>

                        <v-tab-item>
                             <v-data-table
                                :headers="headers"
                                :items="items"
                                :loading="loading"
                                :footer-props="footer_props"
                                :loading-text="loading_text"
                                :no-data-text="no_data_text"
                                :no-results-text="no_result_text"
                                :search="search"
                                :single-expand="true"
                                show-expand
                            >

                                <template v-slot:item.status="{ item }">
                                    <v-chip color="success" v-if="item.status">Habilitado</v-chip>
                                    <v-chip color="error" v-else>Deshabilitado</v-chip>
                                </template>

                                <template v-slot:item.user.names="{ item }">
                                    <span v-if="item.user !== null" v-text="item.user.names"></span>
                                    <span v-else>PENDIENTE</span>
                                </template>

                                <template v-slot:item.actions="{ item }">
                                    <v-menu offset-y>
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-btn icon v-bind="attrs" v-on="on">
                                                <v-icon>mdi-menu</v-icon>
                                            </v-btn>
                                        </template>
                                        <v-list dense>
                                            
                                            <v-list-item class="px-0">
                                                <v-list-item-content>
                                                    <v-btn small text @click="assignTeacherDialog(item)">Asignar docente</v-btn>
                                                </v-list-item-content>
                                            </v-list-item>
                                            <v-list-item class="px-0">
                                                <v-list-item-content>
                                                    <v-btn small text @click="() => {  course = item; students_dialog = true }">Alumnos</v-btn>
                                                </v-list-item-content>
                                            </v-list-item>
                                            <v-list-item class="px-0">
                                                <v-list-item-content>
                                                    <v-btn small text @click="() => {  course = item; recordings_dialog = true }">Grabaciones</v-btn>
                                                </v-list-item-content>
                                            </v-list-item>
                                            <v-list-item class="px-0">
                                                <v-list-item-content>
                                                    <v-btn small text @click="postponement(item)">Aplazar</v-btn>
                                                </v-list-item-content>
                                            </v-list-item>
                                            <v-list-item class="px-0">
                                                <v-list-item-content>
                                                    <v-btn small text @click="finish_course(item)">Finalizar</v-btn>
                                                </v-list-item-content>
                                            </v-list-item>
                                            <v-list-item class="px-0">
                                                <v-list-item-content>
                                                    <v-btn small text @click="() => { remove_item = item; remove_dialog = !remove_dialog }">Eliminar</v-btn>
                                                </v-list-item-content>
                                            </v-list-item>
                                        </v-list>
                                    </v-menu>
                                </template>

                                <template  v-slot:expanded-item="{ headers, item }">
                                    <td :colspan="headers.length" class="px-0">
                                        <v-simple-table>
                                            <template v-slot:default>
                                                <thead>
                                                    <tr>
                                                        <th class="text-center">Día</th>
                                                        <th class="text-center">Hora de inicio</th>
                                                        <th class="text-center">Hora de termino</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr class="text-center" v-for="(schedule, index) in item.schedule" :key="index">
                                                        <td>{{ schedule.day }}</td>
                                                        <td>{{ schedule.start_time }}</td>
                                                        <td>{{ schedule.end_time }}</td>
                                                    </tr>
                                                </tbody>
                                            </template>
                                        </v-simple-table>
                                    </td>
                                </template>
                            </v-data-table>
                        </v-tab-item>
                    </v-tabs-items>

                </v-card>
            </v-col>
        </v-row>

        <v-dialog v-model="sample_class_dialog" persistent width="800">
            <v-card>
                <v-card-title>Clase Muestra</v-card-title>
                <v-form v-model="sample_class_form" ref="sample_class_form" v-on:submit.prevent="sample_class">
                    <v-card-text>
                        <v-container>
                            <v-row justify="center" align="center">
                                <v-col cols="12">
                                    <v-text-field
                                        v-model="sample_class_data.email"
                                        :rules="[rules.required]"
                                        label="Email"
                                        required
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="12">
                                    <v-text-field
                                        v-model="sample_class_data.phone"
                                        :rules="[rules.required]"
                                        label="Telefono"
                                        required
                                    ></v-text-field>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn text @click="sample_class_dialog = false" :disabled="sample_class_loading">Cancelar</v-btn>
                        <v-btn class="px-3" color="#008dd4" type="submit" :loading="sample_class_loading" dark>Asignar</v-btn>
                    </v-card-actions>
                </v-form>
            </v-card>
        </v-dialog>

        <v-dialog v-model="assign_teacher_dialog" persistent width="800">
            <v-card>
                <v-card-title>Asignar Docente</v-card-title>
                <v-form v-model="assign_teacher_form" ref="assign_teacher_form" v-on:submit.prevent="assign_teacher">
                    <v-card-text>
                        <v-container>
                            <v-row justify="center" align="center">
                                <v-col cols="12">
                                    <v-select
                                        v-model="selected_teacher"
                                        :items="teachers"
                                        filled
                                        :rules="[rules.required]"
                                        color="#000"
                                        item-color="#000"
                                        :item-text="item => item.names+' '+item.paternal_surname+' '+item.maternal_surname"
                                        item-value="id"
                                        no-data-text="Sin elementos registrados"
                                        label="Seleccione docente"
                                    ></v-select>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn text @click="assign_teacher_dialog = false" :disabled="assign_teacher_loading">Cancelar</v-btn>
                        <v-btn class="px-3" color="#008dd4" type="submit" :loading="assign_teacher_loading" dark>Asignar</v-btn>
                    </v-card-actions>
                </v-form>
            </v-card>
        </v-dialog>

        <v-dialog v-model="generate_dialog" persistent width="800">
            <v-card>
                <v-card-title>Atención</v-card-title>
                <v-card-text class="text-center">
                    <v-container fluid>
                        <v-row justify="center" align="center">
                            <v-col cols="12">
                                <v-form ref="courses_bulk" v-on:submit.prevent="courses_bulk">
                                    <v-row no-gutters>
                                        <v-text-field v-model="initial_nomenclature" suffix="-" filled color="#000" label="Nomenclatura inicial" :rules="[rules.required]"></v-text-field>
                                        <v-text-field v-model="final_nomenclature" prefix="-" filled color="#000" label="Nomenclatura final" :rules="[rules.required]"></v-text-field>
                                    </v-row>
                                    <v-select v-model="modality_id" :items="modalities" filled item-text="name" item-value="id" color="#000" label="Modalidad" item-color="#000" :rules="[rules.required]"></v-select>
                                    <v-select v-model="level_id" :items="levels" filled item-text="name" item-value="id" color="#000" label="Nivel" item-color="#000" :rules="[rules.required]"></v-select>
                                    <v-select v-model="teacher_id" :items="teachers" filled item-text="names" item-value="id" color="#000" label="Docente" item-color="#000" no-data-text="Sin registros"></v-select>
                                </v-form>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text color="#000" @click="generate_dialog = false" :disabled="bulk_loading">Cancelar</v-btn>
                    <v-btn color="#008dd4" dark @click="courses_bulk" :loading="bulk_loading">Generar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="remove_dialog" persistent width="400">
            <v-card>
                <v-card-title>
                    Atención
                </v-card-title>
                <v-card-text class="text-center">
                    <p>¿Realmente desea eliminar este elemento?</p>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text color="#000" :disabled="remove_loading" @click="remove_dialog = false">Cancelar</v-btn>
                    <v-btn color="#008dd4" dark :loading="remove_loading" @click="remove">Eliminar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="daily_cleaning_dialog" persistent width="400">
            <v-card>
                <v-card-title>Atención</v-card-title>
                <v-card-text>
                    <p class="text-center">
                        ¿Realmente desea realizar la limpieza de cursos? <br> Esta acción puede tardar varios minutos.
                    </p>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text color="#000" @click="daily_cleaning_dialog = false" :disabled="daily_cleaning_loading">Cancelar</v-btn>
                    <v-btn color="#008dd4" @click="daily_cleaning" dark :loading="daily_cleaning_loading">Aceptar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="languages_dialog" width="800">
            <v-card>
                <v-card-title>Idiomas</v-card-title>
                <v-card-text>
                    <v-simple-table v-if="languages.length > 0">
                        <template v-slot:default>
                            <thead>
                                <tr>
                                    <th>Idioma</th>
                                    <th>Código</th>
                                    <th>Acciones</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(language, index) in languages" :key="index">
                                    <td>{{ language.language }}</td>
                                    <td>{{ language.code }}</td>
                                    <td>
                                        <v-tooltip right>
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-btn icon v-bind="attrs" v-on="on" @click="delete_language(language)">
                                                    <v-icon>mdi-delete</v-icon>
                                                </v-btn>
                                            </template>
                                            <span>Eliminar</span>
                                        </v-tooltip>
                                    </td>
                                </tr>
                            </tbody>
                        </template>
                    </v-simple-table>
                    <template v-else>
                        <h4 class="text-center">Sin lenguajes registrados</h4>
                    </template>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text color="#000" @click="languages_dialog = false">Cerrar</v-btn>
                    <v-btn color="#008dd4" dark @click="() => { languages_dialog = false; new_language_dialog = true }">registrar idioma</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="new_language_dialog" persistent width="800">
            <v-card>
                <v-card-title>Nuevo idioma</v-card-title>
                <v-card-text>
                    <v-container>
                        <v-row>
                            <v-col cols="12">
                                <v-form ref="new_language_form" v-on:submit.prevent="new_language">
                                    <v-text-field v-model="language" filled color="#000" label="Idioma" :rules="[rules.required]"></v-text-field>
                                    <v-text-field v-model="code" filled color="#000" label="Código" :rules="[rules.required]"></v-text-field>
                                    <v-file-input v-model="image[0]" filled color="#000" label="Imagen" :rules="[rules.required]"></v-file-input>
                                </v-form>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text color="#000" @click="new_language_dialog = false" :disabled="new_language_loading">Cancelar</v-btn>
                    <v-btn color="#008dd4" dark @click="new_language" :loading="new_language_loading">Registrar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="recordings_dialog" fullscreen hide-overlay transition="dialog-bottom-transition">
            <v-card v-if="selected_course">
                <v-toolbar flat color="#008dd4" dark>
                    <v-btn icon @click="recordings_dialog = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                    <v-toolbar-title>Grabaciones por curso : {{ selected_course.name }}</v-toolbar-title>
                </v-toolbar>
                <v-container class="py-0" fluid>
                    <v-row justify="center" align="center">
                        <v-col cols="12" class="pa-0">
                            <v-sheet class="" color="#008dd4" height="10vh"></v-sheet>
                        </v-col>
                        <v-col cols="12" lg="6" md="6" sm="12" style="margin-top: -60px">
                            <template v-if="selected_course.recordings && selected_course.recordings.length > 0">
                                <template v-for="(record, index) in selected_course.recordings">
                                    <v-card class="mt-3" outlined :key="index">
                                        <v-list-item three-line>
                                            <v-list-item-content>
                                                <div class="overline mb-4">{{ record.date }}</div>
                                                <v-list-item-title class="mb-1">
                                                    <strong>
                                                        {{ record.name }}
                                                    </strong>
                                                </v-list-item-title>
                                                <v-list-item-subtitle>{{ record.description }}</v-list-item-subtitle>
                                            </v-list-item-content>
                                            <v-list-item-avatar tile size="80">
                                                <v-img :src="initial_avatar+record.name+final_avatar"></v-img>
                                            </v-list-item-avatar>
                                        </v-list-item>
                                        <v-card-actions>
                                            <v-btn text :href="'/watch/'+record.folio">
                                                <v-icon class="mr-3" color="red">mdi-play-circle</v-icon>
                                                ver
                                            </v-btn>
                                        </v-card-actions>
                                    </v-card>
                                </template>
                            </template>
                            <v-card v-else>
                                <v-card-title>
                                    Grabaciones
                                </v-card-title>
                                <v-card-text>
                                    <p>Sin grabaciones registradas</p>
                                </v-card-text>
                            </v-card>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card>
        </v-dialog>

        <v-dialog v-model="finish_course_dialog" persistent width="800" scrollable>
            <v-card >
                <v-card-title>
                    Finalizar curso: {{ selected_course.name }}
                    <v-spacer></v-spacer>
                    <v-btn icon @click="finish_course_dialog = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text>
                    <v-form ref="postponement_form">
                        <v-card-subtitle class="px-0">Seleccione cual es la continuacion del curso</v-card-subtitle>
                        <v-menu ref="menu"  transition="scale-transition" offset-y min-width="auto">
                            <template v-slot:activator="{ attrs, on }">
                                <v-select
                                :items="items"
                                v-model="continuation_course_id"
                                label="Seleccione el siguiente curso."
                                item-text="name"
                                item-value="id"
                                ></v-select>
                            </template>
                            
                        </v-menu>
                    </v-form>        
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <template >
                        <v-btn text @click="finish_course_dialog = false">cancelar</v-btn>
                        <v-btn color="primary" @click="finish_course_store" :loading="finish_course_loading">Finalizar</v-btn>
                    </template>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="postponements_dialog" persistent width="800" scrollable>
            <v-card v-if="postponements.length > 0" :loading="postponement_loading" :disabled="postponement_loading" >
                <v-card-title>
                    Aplazar curso: {{ postponements[0].name }}
                    <v-spacer></v-spacer>
                    <v-btn icon @click="postponements_dialog = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-card-title>
                <v-divider></v-divider>
                <v-alert type="error" class="rounded-0" prominent v-if="postponement_window == 1 && postponements[1].length > 0">
                    <v-row align="center">
                        <v-col class="grow">
                            El curso ya fué aplazado anteriormente
                        </v-col>
                        <v-col class="shrink">
                            <v-btn @click="postponement_window++">ver historial</v-btn>
                        </v-col>
                    </v-row>
                </v-alert>
                <v-card-text>
                    <v-window v-model="postponement_window">

                        <v-window-item :value="1">
                            <v-form ref="postponement_form">
                                <v-card-subtitle class="px-0">Seleccione la fecha a la cual será aplazado el curso</v-card-subtitle>
                                <v-menu ref="menu" v-model="postponement_date_dialog" return-value.sync="postponement_date" transition="scale-transition" offset-y min-width="auto">
                                    <template v-slot:activator="{ attrs, on }">
                                        <v-text-field :rules="[rules.required]" outlined label="Fecha" v-model="postponement_date" prepend-icon="mdi-calendar" readonly v-bind="attrs" v-on="on"></v-text-field>
                                    </template>
                                    <v-date-picker v-model="postponement_date" no-title scrollable>
                                        <v-spacer></v-spacer>
                                        <v-btn text color="primary" @click="$refs.menu.save(postponement_date)">Seleccionar</v-btn>
                                    </v-date-picker>
                                </v-menu>
                            </v-form>
                        </v-window-item>
                        
                        <v-window-item :value="2">
                            <v-simple-table>
                                <template v-slot:default>
                                    <thead>
                                        <tr>
                                            <th>Fecha</th>
                                            <th>Fecha anterior</th>
                                            <th>Fecha aplazada</th>
                                            <th>Alumnos a la fecha</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(postponement, index) in postponements[1]" :key="index">
                                            <td>{{ postponement.register_date }}</td>
                                            <td>{{ postponement.previous_date }}</td>
                                            <td>{{ postponement.new_date }}</td>
                                            <td>{{ postponement.number_students }}</td>
                                        </tr>
                                    </tbody>
                                </template>
                            </v-simple-table>
                        </v-window-item>

                    </v-window>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <template v-if="postponement_window === 1">
                        <v-btn text @click="postponements_dialog = false">cancelar</v-btn>
                        <v-btn color="primary" @click="postponement_store" :loading="postponement_loading">Aplazar</v-btn>
                    </template>
                    <v-btn text v-else @click="postponement_window = 1">atrás</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        
        <create :dialog="create_dialog" :store_url="store_url" :modalities="modalities" :levels="levels" :teachers="teachers" :languages="languages" :onsite="tabs"></create>
        <students :dialog="students_dialog" :course="selected_course"></students>
        <links :dialog="links_dialog" :course="course"></links>
    </v-container>
</template>
<script>

import create from './create'
import students from './students'
import links from './links'
import iziToast from 'izitoast'

export default {
    components:{
        create,
        students,
        links
    },

    data: () => ({
        //urls
        data_url:"/courses",
        store_url:"/courses/store",
        assign_teacher_url:"/courses/assign_teacher",
        sample_class_url:"/courses/sample_class",
        finish_url:"/courses/finish_course",
        remove_url:"/courses/remove",
        daily_cleaning_url:"/courses/daily_cleaning/bulk",
        language_store_url:"/languages/store",
        language_delete_url:"/languages/delete",

        //dialogs
        create_dialog:false,
        assign_teacher_dialog:false,
        generate_dialog:false,
        remove_dialog:false,
        students_dialog:false,
        daily_cleaning_dialog:false,
        languages_dialog:false,
        new_language_dialog:false,
        recordings_dialog:false,
        postponements_dialog:false,
        postponement_date_dialog:false,
        links_dialog:false,
        sample_class_dialog:false,
        finish_course_dialog:false,

        //assign teacher props
        selected_teacher:"",
        assign_teacher_form:false,

        //sample class
        sample_class_form:false,
        sample_class_data: {},

        // loadings
        bulk_loading:false,
        assign_teacher_loading:false,
        remove_loading:false,
        daily_cleaning_loading:false,
        new_language_loading:false,
        sample_class_loading: false,
        finish_course_loading:false,

        //bulk models
        initial_nomenclature:"",
        final_nomenclature:"",
        teacher_id:"",
        level_id:"",
        modality_id:"",
        continuation_course_id:0,

        //rules
        initial_avatar:"https://ui-avatars.com/api/?name=",
        final_avatar:"&background=random",

        //rules
        rules:{
            required: v => !!v || 'El campo es requerido',
        },

        //props
        items:[],
        levels:[],
        modalities:[],
        teachers:[],
        languages:[],
        course:"",
        selected_course:"",
        total_students_verified:"",
        remove_item:"",
        total_verified:0,
        tabs:0,
        postponements:[],
        postponement_date:"",
        postponement_window:1,
        postponement_loading:false,

        //new_language_models
        language:"",
        code:"",
        image:[],

        //data table props
        color:"#818181",
        search:"",
        loading:"#008dd4",
        loading_text:"Cargando...",
        no_data_text:"Sin elementos registrados",
        no_result_text:"Sin coincidencias",
        headers:[
            { text:'ID', value:'id' },
            { text:'Nombre', value:'name' },
            { text:'Inicio', value:'start_date' },
            { text:'Registrados', value:'total_registered' },
            { text:'Verificados', value:'total_verified' },
            { text:'Idioma', value:'language.language' },
            { text:'Modalidad', value:'modality.name' },
            { text:'Nivel', value:'level.name'},
            { text: 'Docente', value: 'user.names' },
            { text:'status', value:'status' },
            { text: 'Acciones', value:'actions', sorteable:false},
            { text: 'Horario', value: 'data-table-expand' },
        ],
        footer_props:{
            itemsPerPageText:"Filas por página",
            showCurrentPage:true,
            itemsPerPageAllText:"Todo",
            showFirstLastPage:true,
        },

    }),

    watch:{
        course:function(){
            this.loading = "#008dd4";
            axios.get(this.data_url, { params: { details:this.course.id } }).then(response => {
                this.selected_course = response.data.course
                this.loading = false;
            }).catch(error => {
                this.loading = false;
                console.log(error)
            })
        }
    },

    mounted(){
        this.getData()
    },

    methods:{
        finish_course:function(item){
            this.finish_course_dialog = true
            this.selected_course = item
        },
        finish_course_store:function(){
            var t = this
            this.finish_course_loading = true
            axios.post(this.finish_url ,{finish_course:this.selected_course.id, continuation_course:this.continuation_course_id})
            .then(response =>{
                iziToast.success({
                    title:"Correcto",
                    message:"La clase se finalizo de manera correcta",
                    position:"topRight"
                })
            }).catch(error =>{
                console.log('error')
                console.log(error)
                iziToast.error({
                    title:"Error",
                    message:error.response.data.error,
                    position:'topRight'
                })
            }).finally(() => {
                console.log('finally')
                t.finish_course_dialog = false
                t.finish_course_loading = false
            } )
        },

        getData:function(){
            this.loading = '#008dd4'
            axios.get(this.data_url, { params:{ ajax:true, onsite:this.tabs } }).then(response => {
                this.items = response.data.items
                this.modalities = response.data.modalities
                this.levels = response.data.levels
                this.teachers = response.data.teachers
                this.languages = response.data.languages
                this.total_verified = response.data.total_verified

                for(let item of this.items){
                    this.$set(item, 'total_students_verified', 0)
                    for(let student of item.students){
                        student.verified ? item.total_students_verified++ : ''
                    }
                }

                this.loading = false
            }).catch(error => {
                this.loading = false
            })
        },

        sampleClassDialog:function(item){
            this.selected_course = item
            this.sample_class_dialog = true
        },

        assignTeacherDialog:function(item){
            this.selected_course = item
            this.assign_teacher_dialog = true
        },

        sample_class:function(){
            if(this.$refs.sample_class_form.validate()){
                this.sample_class_loading = true
                let data = {}
                data.course_id = this.selected_course.id
                data.email = this.sample_class_data.email
                data.phone = this.sample_class_data.phone

                axios.post(this.sample_class_url, data).then(response => {
                    iziToast.success({
                        title:"Correcto",
                        message:"Clase muestra asignada correctamente",
                        position:"topRight"
                    })
                    this.getData()

                }).catch(error => {
                    console.log(error.response)
                    error.response.data.errors.phone.forEach(error => {
                        iziToast.error({
                            title:"Error",
                            message:error,
                            position:'topRight'
                        })
                    });
                    error.response.data.errors.email.forEach(error => {
                        console.log(error)
                        iziToast.error({
                            title:"Error",
                            message:error,
                            position:'topRight'
                        })
                    });
                }).finally(()=>{
                    this.sampleClassReset()
                })
            }
        },

        assign_teacher:function(){
            if(this.$refs.assign_teacher_form.validate()){
                this.assign_teacher_loading = true
                let data = {}
                data.course_id = this.selected_course.id
                data.teacher_id = this.selected_teacher

                axios.post(this.assign_teacher_url, data).then(response => {
                    this.assignTeacherReset()
                    iziToast.success({
                        title:"Correcto",
                        message:"Docente asignado correctamente",
                        position:"topRight"
                    })
                    this.getData()

                }).catch(error => {
                    this.assignTeacherReset()
                    error.response.data.error.forEach(error => {
                        iziToast.error({
                            title:"Error",
                            message:error,
                            position:'topRight'
                        })
                    });
                })
            }
        },

        assignTeacherReset:function(){
            this.assign_teacher_loading = false
            this.assign_teacher_dialog = false
            this.selected_course = ""
            this.$refs.assign_teacher_form.reset()
        },
        sampleClassReset:function(){
            this.sample_class_loading = false
            this.sample_class_data = {}
            this.sample_class_dialog = false
        },

        courses_bulk_request: async function(data){
            let response = null
            try{
                return response = await axios.post("/courses/generate_bulk", data);
                
            }catch(err){
                if(err.response.data.nomenclature){
                    iziToast.error({
                        title:"Error",
                        position:"topRight",
                        message:"Las nomenclaturas ya están en uso"
                    })
                }
                return false
            }
        },

        courses_bulk: async function(){
            if(this.$refs.courses_bulk.validate()){
                this.bulk_loading = true

                let data = {}
                data.initial_nomenclature = this.initial_nomenclature
                data.final_nomenclature = this.final_nomenclature
                data.teacher_id = this.teacher_id
                data.level_id = this.level_id
                data.modality_id = this.modality_id

                let response = await this.courses_bulk_request(data)

                if(response === false){
                    iziToast.error({
                        title:"Error",
                        position:"topRight",
                        message:"Ha ocurrido un error al generar los cursos"
                    })

                    this.bulk_loading = false

                    return
                }

                this.$refs.courses_bulk.reset()

                iziToast.success({
                    title:"Correcto",
                    position:"topRight",
                    message:"Se han generado los cursos correctamente"
                })

                this.getData()

                this.generate_dialog = this.bulk_loading = false
            }
        },

        remove: function(){
            this.remove_loading = true
            axios.post(this.remove_url, { id:this.remove_item.id }).then(response => {
                iziToast.success({
                    title:"Correcto",
                    message:"Curso eliminado correctamente",
                    position:"topRight"
                })
                this.getData()
                
            }).catch(error => {
                if(error.response.data.students){
                    iziToast.error({
                        title:"Error",
                        message:"Existen alumnos registrados a este curso",
                        position:"topRight"
                    })
                }
            })

            this.remove_loading = this.remove_dialog = false
        },

        daily_cleaning:function(){
            this.daily_cleaning_loading = true
            axios.post(this.daily_cleaning_url).then(response => {
                iziToast.success({
                    title:"Correcto",
                    message:"Limpieza realizada correctamente",
                    position:"topRight"
                })

                this.getData()
                this.daily_cleaning_loading = this.daily_cleaning_dialog = false

            }).catch(error => {
                iziToast.error({
                    title:"Error",
                    message:"Ha ocurrido un error en la comunicación con el servidor",
                    position:"topRight"
                })

                this.getData()
                this.daily_cleaning_loading = this.daily_cleaning_dialog =false
            })
        },

        new_language:function(){
            if(this.$refs.new_language_form.validate()){
                this.new_language_loading = true
                let data = new FormData()
                data.append('language', this.language)
                data.append('code', this.code)
                data.append('image', this.image[0])

                axios.post(this.language_store_url, data).then(response => {
                    iziToast.success({
                        title:"Correcto",
                        message:"Idioma registrado correctamente",
                        position:"topRight"
                    })
                    
                    this.$refs.new_language_form.reset()
                    this.new_language_dialog = this.new_language_loading = false

                    this.getData()

                }).catch(error => {
                    this.new_language_loading = false
                    if(error.response.data.errors){
                        for(let prop in error.response.data.errors){
                            for(let message of error.response.data.errors[prop]){
                                iziToast.error({
                                    title:"Error",
                                    position:'topRight',
                                    message: message
                                })
                            }
                        }
                    }else{
                        iziToast.error({
                            title:"Error",
                            position:'topRight',
                            message: "Ha ocurrido un error en la comunicación con el servidor, intente más tarde"
                        })
                    }
                })
            }
        },

        delete_language:function(item){
            let data = {}
            data.language_id = item.id
            axios.post(this.language_delete_url, data).then(response => {
                iziToast.success({
                    title:"Correcto",
                    message:"Idioma eliminado correctamente",
                    position:"topRight"
                })

                this.getData()

            }).catch(error => {
                if(!error.response.data.courses){
                    iziToast.error({
                        title:"Error",
                        position:'topRight',
                        message: "El idioma tiene cursos registrados"
                    })

                    return
                }

                if(!error.response.data.success){
                    iziToast.error({
                        title:"Error",
                        position:'topRight',
                        message: "Ha ocurrido un error en la comunicación con el servidor, intente más tarde"
                    })

                    return
                }
            })
        },

        postponement:function(item)
        {
            axios.get('/courses/postponements/'+item.id, { params:{ ajax:true } }).then(response => {
                this.postponements[0] = item
                this.postponements[1] = response.data.postponements
                this.postponements_dialog = true
            }).catch(error => {

                iziToast.error({
                    title:"Error",
                    position:'topRight',
                    message: error.response.data.error
                })

                return
            })
        },

        postponement_store:function()
        {
            if(this.$refs.postponement_form.validate())
            {
                this.postponement_loading = true

                let data = {}
                data.new_date  = this.postponement_date

                axios.post('/courses/postponements/'+this.postponements[0].id, data).then(response => {
                    this.getData()

                    this.postponement_loading = false
                    this.$refs.postponement_form.reset()
                    this.postponements = []
                    this.postponements_dialog = false


                    iziToast.success({
                        title:"Correcto",
                        position:'topRight',
                        message: "El curso se aplazó correctamente"
                    })

                }).catch(error => {
                    this.postponement_loading = false

                    iziToast.error({
                        title:"Error",
                        position:'topRight',
                        message: error.response.data.error
                    })
                })
            }
        }
    }
}
</script>
